export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.localSideNavigations = payload;

  return newState;
};
